<template>
    <div id="teamCreatePage" :class="'popupPage anim'+ ( open ? ' open' : '' )">
        <div v-if="open" class="container h-100">
            <form @submit.prevent="submit" class="row h-100">
                <div class="col-md-6 h-100 m-auto text-center d-flex flex-column">
                    <div class="header mb-3">
                        <h3 class="m-auto">{{ $t('team.create_title') }}</h3>
                        <a @click.prevent="open = false;btnSfx();" href="#" class="close"></a>
                    </div>

                    <div class="d-flex justify-content-center my-4">
                        <img src="/images/home/teams/search-team-bg.png" class="vh-10" />
                    </div>

                    <h5 class="text-orange mb-0" v-html="$t('team.create_desc')"></h5>
                    <div><hr style="width: 3em;"/></div>

                    <div class="form-group mb-5 pl-3 pr-3 pl-md-5 pr-md-5">
                        <label for="teamName" class="mb-3">{{ $t('team.create_name_label') }}</label>
                        <b-form-input v-model="name" id="teamName" type="text" class="green-b text-center" size="lg"></b-form-input>
                        <div class="alert alert-dark small mt-3" v-html="$t('team.create_info')"></div>
                    </div>

                    <div class="form-group mt-auto mb-5">
                        <b-button @click="btnSfx();" type="submit" variant="primary" size="lg" class="pl-5 pr-5" >
                            {{ $t('team.create_create_btn') }}
                        </b-button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'

import api from '../../api'


const CreatePopup = Vue.component('team-create-popup', {
    data() {
        return {
            open: false,
            name: "",
        }
    },
    methods:{
        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },
        show() {
            this.open = true;
            this.name = "";
        },
        hide() {
            this.open = false;
        }, 

        submit(){
            if(this.name.trim() == "") return;
            const $this = this;

            this.$bvModal.msgBoxConfirm(this.$t('team.create_confirm_popup_text', { name: this.name }), {
                title: this.$t('team.create_confirm_popup_title'),
                size: 'sm',
                buttonSize: 'lg',
                okTitle: this.$t('team.create_confirm_popup_confirm_btn'),
                cancelTitle: this.$t('base.btn_cancel'),
                modalClass: 'confirmModal',
                okVariant: 'primary',
                hideHeaderClose: false,
                centered: true,
            })
            .then(value => {
                if(value){
                    api.teamsCreate(this.name.trim()).then(res => {
                        // reload my data
                        $this.$store.dispatch('auth/getMe');
                        $this.hide();
                    })
                    .catch(err => {
                        api.baseErrorHendler(err);
                    });
                }
            })
            .then(value => {
                $this.$store.dispatch('sound/sfx','Button');
            });
        } 
    },
    watch: {
        open(){
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            document.body.scrollTop = 0; // For Safari
            if(this.open) document.body.classList.add("lock");
            else document.body.classList.remove("lock");
        }
    }
})

export default CreatePopup
</script>